module.exports = "<div :class=\"[fixed ? 'navbar-fixed' : '']\"> <nav> <div class=nav-wrapper> <form> <div class=input-field> <input v-el:input :id=id type=search required :placeholder=placeholder :value=value> <label :for=id><icon value=search></icon></label> <icon value=close @click=close></icon> </div> </form> </div> </nav> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/navbar/search-bar.vue
 ** module id = 351
 ** module chunks = 0
 **/